import React from 'react'
import RFPModuleTemplate from './RFPModuleTemplate'

const AIRFPCopilot = () => (
  <RFPModuleTemplate
    title="AI RFP Copilot"
    description="Generate, rewrite, and validate RFP content using guided AI prompts and context."
    features={[
      'Prompt templates for each RFP section',
      'AI rewrite suggestions with tone controls',
      'Auto summary and compliance checks'
    ]}
  />
)

export default AIRFPCopilot
